/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { HttpBackend } from "@angular/common/http";

import { Router } from "@angular/router";
import { API_PATH } from "src/environments/config";

@Injectable({
  providedIn: "root",
})
export class InventoryService {
  httpWithoutInterceptor: HttpClient;

  constructor(
    private http: HttpClient,
    private router: Router,
    private httpBackend: HttpBackend
  ) {
    this.httpWithoutInterceptor = new HttpClient(httpBackend);
  }

  inventoriesByInventoryGroup(
    groupId: string,
    key: string,
    withoutInterceptor?
  ) {
    console.log("withoutInterceptor", withoutInterceptor);
    let params = new HttpParams()
      .set("groupId", groupId)
      .set("key", key)
      .set("clickToCall", "clickToCall");
    return (withoutInterceptor
      ? this.httpWithoutInterceptor
      : this.http
    ).get<any>(API_PATH.apis.inventoriesByInventoryGroup, {
      params: params,
    });
  }
  inventoriesList(
    searchText?,
    currentPage?,
    limit?,
    profile?,
    isSortByName?,
    businessUnit?,
    filterData?
  ) {
    let params = new HttpParams();
    params = searchText
      ? params.set("searchText", searchText).set("onlyProduct", "true")
      : params;
    params = currentPage ? params.set("page", currentPage) : params;
    params = limit ? params.set("limit", limit) : params;
    params = profile ? params.set("shippingProfile", profile) : params;
    params = params.set("clickToCall", "clickToCall");
    params = isSortByName ? params.set("isSortByName", isSortByName) : params;
    params = businessUnit ? params.set("busUnitId", businessUnit) : params;
    params = filterData?.categories
      ? params.set("categories", JSON.stringify(filterData.categories))
      : params;
    params = filterData?.gradeFilters
      ? params.set("gradeFilters", JSON.stringify(filterData.gradeFilters))
      : params;
    params = filterData?.isOutOfStock
      ? params.set("excludeInStock", "true")
      : params;
    params = filterData?.isInStock
      ? params.set("includeInStock", "true")
      : params;
    params = filterData?.minMSRP
      ? params.set("minMSRP", filterData.minMSRP)
      : params;
    params = filterData?.maxMSRP
      ? params.set("maxMSRP", filterData.maxMSRP)
      : params;
    params = filterData?.minWSRP
      ? params.set("minWSRP", filterData.minWSRP)
      : params;
    params = filterData?.maxWSRP
      ? params.set("maxWSRP", filterData.maxWSRP)
      : params;
    return this.http.get<any>(API_PATH.apis.server + "/inventories", {
      params: params,
    });
  }
  updateInventory(data, id) {
    return this.http.put<any>(
      API_PATH.apis.server + "/inventories/" + id,
      data
    );
  }
}
